import React, { useState } from 'react';
import { Layout, Card, Button, Input, Typography, Space, Switch, Divider } from 'antd';
import { sendMessage } from '../services/consultation';
import { testDirectApi } from '../utils/directApiTest';
import { simplestApiTest, proxyApiTest } from '../utils/simpleApiTest';

const { Content } = Layout;
const { TextArea } = Input;
const { Title, Text } = Typography;

const ApiTest = () => {
  const [prompt, setPrompt] = useState('你好，我想了解一下中医养生');
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [useDirect, setUseDirect] = useState(false);

  const handleTest = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);
    
    try {
      if (useDirect) {
        const result = await testDirectApi(prompt);
        if (result.success) {
          setResponse(result.data);
        } else {
          setError(`直接调用失败: ${result.error}`);
        }
      } else {
        const result = await sendMessage(prompt);
        setResponse(result);
      }
    } catch (err) {
      setError(err.message || '调用失败');
    } finally {
      setLoading(false);
    }
  };

  const handleSimpleTest = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);
    
    try {
      const result = await simplestApiTest();
      if (result.success) {
        setResponse(result.data);
      } else {
        setError(`简化测试失败: ${result.error}`);
      }
    } catch (err) {
      setError(err.message || '调用失败');
    } finally {
      setLoading(false);
    }
  };

  const handleDirectTest = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);
    
    try {
      const result = await simplestApiTest();
      if (result.success) {
        setResponse(result.data);
      } else {
        setError(`直接API调用失败: ${result.error}`);
      }
    } catch (err) {
      setError(err.message || '调用失败');
    } finally {
      setLoading(false);
    }
  };

  const handleProxyTest = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);
    
    try {
      const result = await proxyApiTest();
      if (result.success) {
        setResponse(result.data);
      } else {
        setError(`代理调用失败: ${result.error}`);
      }
    } catch (err) {
      setError(err.message || '调用失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Content style={{ padding: '50px' }}>
        <Card title="API 测试工具">
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Switch 
                checked={useDirect} 
                onChange={setUseDirect} 
                style={{ marginRight: '10px' }}
              />
              <Text>使用直接API调用 (绕过代理)</Text>
            </div>
            
            <Divider />
            
            <Space>
              <Button onClick={handleSimpleTest} type="primary">
                运行最简化测试
              </Button>
              
              <Button onClick={handleDirectTest} type="primary" danger>
                直接通义千问测试
              </Button>
              
              <Button onClick={handleProxyTest} type="primary" style={{ background: '#52c41a', borderColor: '#52c41a' }}>
                代理API测试
              </Button>
            </Space>
            
            <Divider />
            
            <div>
              <Title level={5}>输入:</Title>
              <TextArea
                rows={4}
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
              />
            </div>
            
            <Button 
              type="primary" 
              onClick={handleTest}
              loading={loading}
            >
              测试API
            </Button>
            
            {error && (
              <div>
                <Title level={5}>错误:</Title>
                <Text type="danger">{error}</Text>
              </div>
            )}
            
            {response && (
              <div>
                <Title level={5}>响应:</Title>
                <pre style={{ backgroundColor: '#f5f5f5', padding: '10px', borderRadius: '4px', overflow: 'auto' }}>
                  {JSON.stringify(response, null, 2)}
                </pre>
              </div>
            )}
          </Space>
        </Card>
      </Content>
    </Layout>
  );
};

export default ApiTest; 